import { FunctionComponent } from 'react';
import Groups from '../../Groups/GroupsContainer';

type FC = FunctionComponent;

const BulkCollectionContainer: FC = () => {
  return <Groups type="Collection" />;
};

export default BulkCollectionContainer;
